export default __webpack_public_path__ + "static/media/star-outline-orange.f78fe91b.svg";